import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";
import LandingPageContent from "views/landing/LandingPageContent";
import MainLayout from "views/landing/MainLayout";
import { Card } from "views/landing/components/Card/Card";

const App = () => {
  const { width } = useWindowSize();
  const isMobile = width < 640;
  const setAppHeight = (): void => {
    const doc = document.documentElement;
    if (isMobile) {
      doc.style.setProperty("--app-height", `${window.innerHeight - 100}px`);
    } else {
      doc.style.setProperty("--app-height", `${window.innerHeight - 90}px`);
    }
  };

  window.addEventListener("orientationchange", setAppHeight);

  useEffect(() => {
    setAppHeight();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<LandingPageContent />} />
        <Route path="card" element={<Card />} />
      </Route>
    </Routes>
  );
};

export default App;
